export const styles = {
    pageContainer: {
        // On iOS Safari 100vh is the height the page would have with the browser's bars hidden,
        // which is taller than what is on screen — so a page whose content fits still scrolled, by
        // about a bar's worth. dvh is the visible height; vh stays as the fallback.
        minHeight: '100vh',
        '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },

    // Under the header bar, fading into the page.
    gradientOverlay: (primaryColor: string) => ({
        position: 'absolute',
        top: { xs: 56, sm: 64 },
        left: 0,
        right: 0,
        height: 300,
        background: `linear-gradient(180deg, ${primaryColor}15 0%, transparent 100%)`,
        pointerEvents: 'none',
    }),

    contentContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        py: 4,
        position: 'relative',
        zIndex: 1,
    },

    card: {
        borderRadius: 2,
        overflow: 'hidden',
    },

    cardContent: {
        p: { xs: 2, sm: 4 },
        '&:last-child': { pb: { xs: 2, sm: 4 } },
    },

    footer: {
        mt: 4,
        textAlign: 'center',
        color: 'text.secondary',
        fontSize: '0.875rem',
    },

    footerLink: {
        color: 'primary.main',
        textDecoration: 'none',
        fontWeight: 500,
        '&:hover': { textDecoration: 'underline' },
    },
};
